<template>
	<div id='ae' class='' v-loading='loading'>
		<div class='gPageBorder'>
			<el-form class='gForm' ref="form" :model='form' :rules='rules' label-position="right" label-width="12.5%"
				style=''>
				<!-- <el-form-item :label="$t('psp_app_id')" prop='appId'>
					<label class='aeMg contentColor'
						v-show="isShowCommon(1)">{{(config.data)? config.data.appId : ''}}</label>
					<el-input v-show="isShowCommon()" style='' class='aeMg' v-model='form.appId'></el-input>
				</el-form-item> -->
				<el-form-item :label="$t('app_appName')" prop='appName'>
					<label class='aeMg contentColor'
						v-show="isShowCommon(1)">{{(config.data)? config.data.appName : ''}}</label>
					<el-input v-show="isShowCommon()" style='' class='aeMg' v-model='form.appName'></el-input>
				</el-form-item>
				<el-form-item :label="$t('psp_app_version')" prop='appVersion'>
					<label class='aeMg contentColor'
						v-show="isShowCommon(1)">{{(config.data)? config.data.appVersion : ''}}</label>
					<el-input v-show="isShowCommon()" style='' class='aeMg' v-model='form.appVersion'></el-input>
				</el-form-item>
				<!-- <el-form-item :label="$t('app_introl')" prop='memo'>
					<el-input v-show='isShowCommon()' type="textarea" :autosize="{ minRows: 2, maxRows: 9999}"
						v-model='form.memo' style='float:left;' class='aeMg'>
					</el-input>
				</el-form-item> -->

				<el-form-item :label="$t('app_selectApp')" v-show="isShowCommon()" prop='pspAppUrl'>
					<el-upload class="upload-demo aeMg" :data='uData' drag name='fileUpload' :file-list="fileList"
						:on-success="fileUploadSuccess" :limit="1" :before-upload="fileBeforeUpload"
						:action="fileUploadUrl" :on-remove="handleRemove_1">
						<span>
							<i v-if='upinfo_1' :class="ulinfo.icons[0]"></i>
							<div v-else style='margin-top:10px;display: flex;flex-direction: column;'>
								<i :style="tipColor_1" class="el-icon-upload"></i>
								<el-button style="width: 140px;margin:  0 auto;"
									type='primary'>{{$t('app_reupload')}}</el-button>
							</div>
							<div v-show='upinfo_1' class="el-upload__text">{{ $t('app_ulNormalSt') }}</div>
						</span>
					</el-upload>
				</el-form-item>
				<el-form-item :label="$t('app_certificate_1')" v-show="isShowCommon()" prop='cer1Url'>
					<el-upload class="upload-demo aeMg" :data='uData' drag name='fileUpload' :file-list="fileLists"
						:on-success="fileUploadSuccesss" :limit="1" :before-upload="fileBeforeUpload"
						:action="fileUploadUrl" :on-remove="handleRemove_2">
						<span>
							<i v-if='upinfo_2' :class="ulinfo.icons[0]"></i>
							<div v-else style='margin-top:10px;display: flex;flex-direction: column;'>
								<i :style="tipColor_2" class="el-icon-upload"></i>
								<el-button style="width: 140px;margin:  0 auto;"
									type='primary'>{{$t('app_reupload')}}</el-button>
							</div>
							<div v-show='upinfo_2' class="el-upload__text">{{ $t('app_ulNormalSt') }}</div>
						</span>
					</el-upload>
				</el-form-item>
				<el-form-item :label="$t('app_certificate_2')" v-show="isShowCommon()" prop='cer2Url'>
					<el-upload class="upload-demo aeMg" :data='uData' drag name='fileUpload' :file-list="fileListss"
						:on-success="fileUploadSuccessss" :limit="1" :before-upload="fileBeforeUpload"
						:action="fileUploadUrl" :on-remove="handleRemove_3">
						<span>
							<i v-if='upinfo_3' :class="ulinfo.icons[0]"></i>
							<div v-else style='margin-top:10px;display: flex;flex-direction: column;'>
								<i :style="tipColor_3" class="el-icon-upload"></i>
								<el-button style="width: 140px;margin:  0 auto;"
									type='primary'>{{$t('app_reupload')}}</el-button>
							</div>
							<div v-show='upinfo_3' class="el-upload__text">{{ $t('app_ulNormalSt') }}</div>
						</span>
					</el-upload>
				</el-form-item>

				<el-form-item
					style='width:calc(100% + 20px);background:black;height:1px;background:#EAEEFA;margin-left:-10px;'>
				</el-form-item>
				<el-form-item style='background:none;'>
					<el-button class='aeMg' @click='cancel' type='' style=''>{{$t('app_cancel')}}</el-button>
					<el-button type='primary' style='' class='aeMg'
						@click="uploadApp('form')">{{$t('app_save')}}</el-button>
				</el-form-item>
			</el-form>

		</div>
	</div>
</template>

<style>
	.contentColor {
		color: #495769
	}

	.avatarF {
		height: auto;
		width: 128px;
		display: block;
	}

	#ae {
		width: 100%;
		background: none;
	}

	.fs-icon {
		font-size: 18px;
	}


	#aeScreenCut img {
		heigth: 100%;
		width: auto;
	}

	/* upload */
	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.capture {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
		width: 120px;
		display: inline-block;
	}

	.capture div {
		float: left;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #20a0ff;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 128px;
		height: 128px;
		line-height: 128px;
		text-align: center;
	}

	/* upload */
	.sm-avatar-uploader-icon {
		font-size: 36px;
		color: #8c939d;
		width: 72px;
		height: 72px;
		line-height: 72px;
		text-align: center;
	}

	.sm-avatar {
		width: 64px;
		height: 64px;
		display: block;
	}

	#aeCpDiv {
		height: 180px;
		width: 120px;
		display: inline-block;
		background: none;
		margin-right: 10px;
	}

	.cImg {
		width: 100%;
	}
</style>

<script>
	import mm from 'moment'
	import tyc from '@/components/global/tyc'
	import tagc from '@/components/global/tagc'
	import MechanismSelector from '@/components/global/mechanism_selector.vue'
	export default {
		components: {
			tyc,
			tagc,
			MechanismSelector
		},
		data() {
			var dstCheck = (rule, value, callback) => {
				if (!value) {
					callback(new Error(this.$t('app_select')));
				} else {
					callback()
				}
			}
			var tagCheck = (rule, value, callback) => {
				if (!value) {
					callback(new Error(this.$t('noVerTag')));
				} else {
					callback()
				}
			}
			var that = this
			return {
				tqobj: '',
				ulinfo: {
					tip: this.$t('app_ulAppState_2'),
					index: 0,
					icons: ['el-icon-upload', 'el-icon-circle-check fs-icon', 'el-icon-close fs-icon']
				},
				mechanismId: window.localStorage['mechanismId'],
				status: '',
				
				stModel: '',
				channels: [],
				channelId: '',
				rules: {
					appId: [{
						required: true,
						message: this.$t('app_input'),
						trigger: 'blur'
					}],
					appName: [{
						required: true,
						message: this.$t('app_inputName'),
						trigger: 'blur'
					}],
					appVersion: [{
						required: true,
						message: this.$t('app_inputVer'),
						trigger: 'blur'
					}],
					verTag: [{
						required: true,
						message: this.$t('app_inputVerTag'),
						trigger: 'blur',
						validator: tagCheck
					}],
					packageName: [{
						required: true,
						message: this.$t('app_inputPkg'),
						trigger: 'blur'
					}],
					memo: [{
						required: true,
						message: this.$t('app_inputIntrol'),
						trigger: 'blur'
					}],
					distributorId: [{
						required: true,
						message: this.$t('app_select'),
						trigger: 'blur'
					}],
					appTypeValue: [{
						required: true,
						message: this.$t('app_select'),
						trigger: 'blur',
						validator: dstCheck
					}],
					// pspAppUrl: [{
					// 	required: true,
					// 	message: this.$t('app_ulApp'),
					// 	trigger: 'blur'
					// }],
					// cer1Url: [{
					// 	required: true,
					// 	message: this.$t('lin_global.pleaseUpload'),
					// 	trigger: 'blur'
					// }],
					// cer2Url: [{
					// 	required: true,
					// 	message: this.$t('lin_global.pleaseUpload'),
					// 	trigger: 'blur'
					// }],
				},
				upinfo_1:true,
				upinfo_2:true,
				upinfo_3:true,
				tipColor_1: {
					color: '#13CE66'
				},
				tipColor_2: {
					color: '#13CE66'
				},
				tipColor_3: {
					color: '#13CE66'
				},
				form: {
					appName: '',
					appVersion:'',
					fileType:1,
					pspAppUrl: '',
					pspAppSize: "",
					pspAppHash: '',
					cer1Url: "",
					cer1Size: "",
					cer1Hash: "",
					cer2Url: "",
					cer2Size: "",
					cer2Hash: "",
				},
				showPic: {
					value: 0,
					data: ''
				},
				srchValue: '',
				installTypes: [{
					label: this.$t('app_autoInstall'),
					value: 0
				}],
				fileSize: 0, // 上传文件大小
				tableData: [],
				checkDesc: '',
				radio: '1',
				smImageUrl: '',
				bgImageUrl: '',
				dialogVisible: false,
				appTypes: [],
				loading: 0,
				loading1: 0,
				loadingBig: 0,
				loadingSm: 0,
				config: {},
				cp0: '',
				cp1: '',
				cp2: '',
				cp3: '',
				cp4: '',
				captures: [],
				fileList: [],
				fileLists: [],
				fileListss:[],
				isUpload: 0,
				index: 1,
				total: 0,
				file_id: 0
			}
		},
		computed: {
			uData() {
				return {
					token: 1234
				}
			},
			fileUploadUrl() {
				// var vl = this.$urls.apkUrl + '?distributorId=' + this.form.distributorId + '&language=' + localStorage.system_lang
				// var vl = "https://tmsadmin.szzt.com.cn/file-management/tms-server-web/appFile/fileupload.do" + '?distributorId=' + this.form.distributorId + '&language=' + localStorage.system_lang
				var vl = this.$urls.webUrl + "/tms-server-web/file/fileupload.do"
				return vl
			},
		},
		created() {
			this.init()
		},
		methods: {
			editApp(row) {

			},
			getChannels() {
				var _this = this
				this.$getChannelList(10000, 1, '', '', '', (res) => {
					if (res.status === 200) {
						_this.channels = res.data
					} else {
						this.$message.error(res.message)
					}
				}, () => {
					// error
					this.$message.error(this.$t('app_rqsError'))
				})
			},
			getStatus(value) {
				switch (value) {
					case '0':
						return this.$t('app_prePushVerify')
					case '1':
						return this.$t('app_preVerify')
					case '2':
						return this.$t('app_verifyPass')
					case '3':
						return this.$t('app_verifyNotPass')
				}
			},
			hBlur(name) {
				this.$refs[name].validate((valid) => {
					if (valid) {} else {
						return false
					}
				})
			},
			dateFormat(row, column) {
				var date = row[column.property]
				if (date === undefined) {
					return ''
				}
				return mm(date).format('YYYY-MM-DD hh:mm:ss')
			},
			deleteCapture0() {
				this.cp0 = ''
				this.cp0Value = ''
			},
			deleteCapture1() {
				this.cp1 = ''
				this.cp1Value = ''
			},
			deleteCapture2() {
				this.cp2 = ''
				this.cp2Value = ''
			},
			deleteCapture3() {
				this.cp3 = ''
				this.cp3Value = ''
			},
			deleteCapture4() {
				this.cp4 = ''
				this.cp4Value = ''
			},
			imgFullUrl(path) {
				if (path) {
					// return this.$host + path
					return this.$urls.prefix + path
				} else {
					return ''
				}
			},
			close() {
				this.$router.go(-1)
			},
			isShowCommon(isShow) {
				// 新建为默认入框，编辑不显示输入框，其他
				if (isShow && (this.config.type === 2 || this.config.type === 3)) {
					return 1
				} else if (!isShow && (this.config.type !== 2 && this.config.type !== 3)) {
					return 1
				} else {
					return 0
				}
			},
			uploadApp(formName) {

				// if (window[this.$route.path]) {
				// 	this.$message.error(this.$t('app_appLoding'))
				// 	return
				// }
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.loading = 1
						if (this.config.type === 1) {
							// 编辑
							this.$editPsp(this.form, (res) => {
								console.log(res)
								this.loading = 0
								if (res.status === 200) {
									this.$router.go(-1)
								} else {
									this.$message(res.message)
								}
							}, () => {
								this.loading = 0
								this.$message(this.$t('app_rqsError'))
							})

						} else {
							// 新增
							this.$changePspAdd(this.form, (res) => {
								console.log(res)
								this.loading = 0
								if (res.status === 200) {
									this.$message.success(res.message)
									// this.$router.go(-1)
									this.$setWObj("changePspDetail", {
										data: res.data,
										type:1
									});
									this.$router.push({
										path: '/changePsp/detail',
									})
								} else {
									this.$message(res.message)
								}
							}, () => {
								this.loading = 0
								this.$message(this.$t('app_rqsError'))
							})
						}
					} else {
						return false
					}
				})
			},
			// 应用上传成功
			fileUploadSuccess(res, file) {
				if (res.status === 200) {
					this.form.pspAppUrl = res.fileUrl
					this.form.pspAppSize = res.appSize
					this.form.pspAppHash = res.md5
					this.fileList = [{
						name: file.name
					}]
					this.upinfo_1 = false
					this.tipColor_1 = {
						color: '#13CE66'
					}
				} else {
					this.upinfo_1 = true
					this.form.pspAppUrl = ""
					this.form.pspAppSize = ""
					this.form.pspAppHash = ""
					this.fileList = []
					this.$message.error(res.message)
					this.tipColor_1 = {
						color: '#FF4949'
					}
				}
			},
			// 一级证书成功
			fileUploadSuccesss(res, file) {
				if (res.status === 200) {
					this.form.cer1Url = res.fileUrl
					this.form.cer1Size = res.appSize
					this.form.cer1Hash = res.md5
					this.fileLists = [{
						name: file.name
					}]
					this.upinfo_2 = false
					this.tipColor_2 = {
						color: '#13CE66'
					}
				} else {
					this.upinfo_2 = true
					this.form.cer1Url = ""
					this.form.cer1Size = ""
					this.form.cer1Hash = ""
					this.fileLists = []
					this.$message.error(res.message)
					this.tipColor_2 = {
						color: '#FF4949'
					}
				}
			},
			// 二级证书成功
			fileUploadSuccessss(res, file) {
				if (res.status === 200) {
					this.form.cer2Url = res.fileUrl
					this.form.cer2Size = res.appSize
					this.form.cer2Hash = res.md5
					this.fileListss = [{
						name: file.name
					}]
					this.upinfo_3 = false
					this.tipColor_3 = {
						color: '#13CE66'
					}
				} else {
					this.upinfo_3 = true
					this.form.cer2Url = ""
					this.form.cer2Size = ""
					this.form.cer2Hash = ""
					this.fileListss = []
					this.$message.error(res.message)
					this.tipColor_3 = {
						color: '#FF4949'
					}
				}
			},

			fileBeforeUpload(file) {
				// 不做限制
				// if (file) {
				// 	var ar = file.name.split('.')
				// 	var type = ar[ar.length - 1]
				// 	if (type === 'apk' || type === 'hap') {
				// 		var limit = 500000 // k单位
				// 		if (file.size / 1000 > limit) {
				// 			this.$message.error(this.$t('app_fileOver') + '500M')
				// 			return false
				// 		}
				// 		window[this.$route.path] = 1
				// 		return true
				// 	} else {
				// 		this.$message.error(this.$t('app_onlyApk_2'))
				// 		return false
				// 	}
				// } else {
				// 	this.$message.error(this.$t('app_onlyApk_2'))
				// 	return false
				// }
			},
			// 移除文件
			handleRemove_1(file, fileList) {
				this.fileList = []
				this.upinfo_1 = true
				this.form.pspAppUrl = ""
				this.form.pspAppSize = ""
				this.form.pspAppHash = ""
			},
			// 移除文件
			handleRemove_2(file, fileList) {
				this.fileLists = []
				this.upinfo_2 = true
				this.form.cer1Url = ""
				this.form.cer1Size = ""
				this.form.cer1Hash = ""
			},
			// 移除文件
			handleRemove_3(file, fileList) {
				this.fileListss = []
				this.upinfo_3 = true
				this.form.cer2Url = ""
				this.form.cer2Size = ""
				this.form.cer2Hash = ""
			},
			
			// 移除文件
			handleRemoves(file, fileList) {
				if(this.fileLists.length > 1){
					for (var i = 0; i < this.fileLists.length; i++) {
						if(file.uid == this.fileLists[i].uid){
							if(i == 0){
								this.form.cer1Url = this.form.cer1Url.split(",")[1]
								this.form.cer1Size = this.form.cer1Size.split(",")[1]
								this.form.cer1Hash = this.form.cer1Hash.split(",")[1]
							}else{
								this.form.cer1Url = this.form.cer1Url.split(",")[0]
								this.form.cer1Size = this.form.cer1Size.split(",")[0]
								this.form.cer1Hash = this.form.cer1Hash.split(",")[0]
							}
						}
					}
					this.fileLists = fileList
				}else{
					this.form.cer1Url = ""
					this.form.cer1Size = ""
					this.form.cer1Hash = ""
					this.fileLists = []
				}
				
				console.log(this.form)
				console.log(this.fileLists)
				// console.log(file, fileList)
			},
			fillEdit() {
				var data = this.config.data
				this.form = JSON.parse(JSON.stringify(this.config.data))
				this.fileList = [{
					name: this.form.pspAppUrl
				}]
				this.fileLists = this.form.cer1Url ?  [{
					name: this.form.cer1Url
				}] : []
				this.fileListss = this.form.cer2Url ? [{
					name: this.form.cer2Url
				}] : []
				this.upinfo_1 = false
				this.tipColor_1 = {
					color: '#13CE66'
				}
				this.upinfo_2 = this.form.cer1Url ? false : true
				this.tipColor_2 = {
					color: '#13CE66'
				}
				this.upinfo_3 = this.form.cer2Url ? false : true
				this.tipColor_3 =   {
					color: '#13CE66'
				}
					
				// if (this.form.cer1Url.split(',').length > 1) {
				// 	this.fileLists = [{
				// 			name: this.form.cer1Url.split(',')[0]
				// 		},
				// 		{
				// 			name: this.form.cer1Url.split(',')[1]
				// 		}
				// 	]
				// } else {
				// 	this.fileLists = [{
				// 		name: this.form.cer1Url
				// 	}]
				// }
				console.log(this.fileLists)

			},
			cancel() {
				// cancel
				this.$router.go(-1)
			},
			init() {
				this.config = this.$getWObj().editChangePSPConfig
				console.log('config', this.config)
				// 0新建 1编辑 2展示 3审核
				switch (this.config.type) {
					case 0:
						break
					case 1:
						this.fillEdit()
						break
				}
			},
		},
		mounted() {
			// stModel
			// this.tqobj = {
			// 	keys: ['terminalTypes'],
			// 	callback: data => {
			// 		this.stModel = data[0]
			// 		this.status = '1'
			// 		this.init()
			// 	}
			// }
		}
	}
</script>


// WEBPACK FOOTER //
// changePspEdit.vue?06f1f11c